<template>
  <div class="header-box" @contextmenu.prevent.capture>
    <div class="head-two">
      <div class="container flex-center">
        <div class="left-imgs">
          <img v-if="schoolInfo" class="schoollogo" :src="schoolInfo.school_logo" />
          <span class="split-line"></span>
          <img class="szzyk-img" src="../assets/image/common/szzyk.png" @click="$router.push(`/${school_code}/zy`)" />
        </div>
        <div class="search-middle-box">
          <a class="center-link" href="https://www.scpcfe.cn/kcszjxyjzx/" target="_blank"><img src="../assets/image/common/yanjiu-icon.png" />课程思政教学研究中心</a>
          <div class="search-button" @click="searchMethod">
            <img src="../assets/image/sccj/search.png" />
          </div>
        </div>
        <div class="login-box">
          <div v-if="appsUserInfo && appsUserInfo.name" class="login-dropdown-box">
            <div class="login-after">{{ appsUserInfo.name }}</div>
            <div class="login-sub-box">
              <template v-if="
                  appsUserInfo.user_type == 2 ||
                  (appsUserInfo.user_type == 1 && appsUserInfo.role_ids)
                ">
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/school/resource`" target="_blank">校内共建资源库</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/resource`" target="_blank">备课资源库</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/works`" target="_blank">协同备课</a>
                </div>
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/favorite`" target="_blank">资源收藏</a>
                </div>
              </template>
              <template v-if="
                  appsUserInfo.user_type == 2 ||
                  (appsUserInfo.user_type == 1 && appsUserInfo.role_ids == 2)
                ">
                <div class="hover-item">
                  <a :href="`${services.BEIKE_SERVER}/${school_code}/manage/user`" target="_blank">用户管理</a>
                </div>
              </template>
              <div class="login-lines"></div>
              <div class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/worker`" target="_blank">信息服务中心</a>
              </div>
              <div class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/userInfo`" target="_blank">个人信息设置</a>
              </div>
              <div v-if="!isMobile" class="hover-item">
                <a :href="`${services.APPS_WEB}/${school_code}/editPassword`" target="_blank">修改密码</a>
              </div>
              <div class="hover-item" @click="logoutEvent">
                <a href="javascript:;">退出</a>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="login" @click="loginModal(true)">登 录</div>
            <!-- <router-link class="register" to="/register">个人注册</router-link> -->
            <!-- <a class="free-trial" :href='services.YXT_GW + "/need"' target="_blank">学校免费试用</a> -->
          </template>
        </div>
      </div>

      <div class="container">
        <div class="menu-list">
          <div :class="currentPath == `/${school_code}/sccj` ? 'menu-items active' : 'menu-items'">
            <router-link :to="`/${school_code}/sccj`">首页</router-link>
          </div>
          <template v-for="(item, index) in routeArr">
            <div :class="currentPath.indexOf(item.path) != -1 ? 'menu-items active' : 'menu-items'" :key="index">
              <template v-if="item.type == 'path'">
                <div class="link-nav" @click="clickRouter(item)">{{ item.name }}</div>
              </template>
              <template v-else-if="item.type == 'click'">
                <a href="javascript:void(0)" @click="clickFunc(item)">{{ item.name }}</a>
              </template>
              <template v-else>
                <a :href="item.path" target="_blank">{{ item.name }}</a>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 登录弹层 -->
    <Login ref="loginchild"></Login>
  </div>
</template>

<script>
import services from "../assets/js/services";
import utils from "../assets/js/utils";
import { mapState, mapActions, mapMutations } from "vuex";
// import VueCookies from 'vue-cookies';
import homeData from "../assets/js/homeData";
import Login from "./Login.vue";

export default {
  name: "SccjHeader",
  components: {
    Login,
  },
  data () {
    return {
      utils,
      services,
      isChrome: true,
      loginSignArr: [],
      homeSearchList: homeData.homeSearchList,
      isMobile: utils.isMobile(),
      school_code: localStorage.getItem("schoolCode"),
      currentPath: "",
      routeArr: [
        { name: "使用帮助", type: "click" }
      ],
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: (state) => state.appsLogin.appsUserInfo,
      loginVisible: (state) => state.appsLogin.loginVisible,
      keyWord: (state) => state.search.keyWord,
      loading: (state) => state.search.loading,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
      schoolMenu: state => state.appsLogin.schoolMenu,
      xxzyRouterList: state => state.class.xxzyRouterList
    }),
  },
  created () {
    // this.getLoginSchoolInfo({ school_code: this.school_code, label: 'kcsz' }).then(res => {
    //   if(res.code == '0000'){
    //     utils.setTitle(this.schoolInfo.school_name)
    //   }
    // })
  },
  async mounted () {
    this.currentPath = this.$route.path;
    await this.getSchoolMenuData();
    if (this.schoolMenu && !this.schoolMenu.close_bkzyk) {
      this.routeArr.unshift({
        name: "在线备课",
        type: "click"
      });
    }


    if (this.schoolMenu?.special) {
      this.routeArr.unshift({
        name: this.schoolMenu.special.name,
        path: "/zy/region",
        type: "path"
      });
    }


    if (this.schoolMenu?.course) {
      this.routeArr.unshift({
        name: this.schoolMenu.course.name,
        path: "/zy/szsfkc",
        type: "path",
      });
    }

    // 开通后显示学习资源库
    if (this.schoolMenu.open_xxzyk) {
      if (this.school_code == utils.sdcm_code) {
        this.sdcmRouteArr.push({
          name: "培训资源",
          path: "/zy/xxzyk",
          type: "path",
        });
      } else {
        this.routeArr.push({
          name: "教师研修库",
          path: "/zy/xxzyk",
          type: "path",
        });
      }
    }

    if (this.schoolMenu?.open_szztk) {
      this.routeArr.unshift({
        name: "思政专题库",
        path: "/zy/szztk",
        type: "path"
      });
    }
    if (this.schoolMenu?.open_cases) {
      this.routeArr.unshift({
        name: "案例资源库",
        path: "/zy/alzyk",
        type: "path"
      });
    }
    this.routeArr.unshift({ name: "课程思政元素库", path: "/zy/szzyk", type: "path" })
    // 是否开启校本元素图谱
    this.routeArr.unshift({
      name: "思政元素图谱",
      type: "path",
      path: "/zy/elementGraph",
    },);

    // 是否开启能力图谱
    if (this.schoolMenu?.open_ability == 1) {
      this.routeArr.unshift({
        name: "专业能力图谱",
        type: "path",
        path: "/zy/majorGraph",
      },);
    }
    // 为给运维扫描添加
    if (this.$route.query.needLogin) {
      this.loginModal(true);
    }
    this.isChrome = utils.bowerUserAgent();
    this.getAppsLoginUserInfo();
  },
  methods: {
    ...mapMutations([
      "setSearchKeyWord",
      "setAppsLoginVisible",
      "setSearchSzzykData",
      "setSearchElementData",
      "resetSzzykTotal",
    ]),
    ...mapActions([
      "getAppsImageCaptcha",
      "getLoginSchoolInfo",
      "getAppsLoginUserInfo",
      "requestAppsLogout",
      "goAppsDetailsBeforeLogin",
      "schoolLoginRedirect",
      "getSchoolMenuStatus"
    ]),
    async getSchoolMenuData () {
      if (!this.schoolMenu) {
        await this.getSchoolMenuStatus(this.school_code);
      }
    },
    changeInputVal (e) {
      this.setSearchKeyWord({ data: e.target.value });
    },
    clearInputVal () {
      this.setSearchKeyWord({ data: "" });
      this.setSearchSzzykData({ data: [] });
      this.setSearchElementData({ data: [] });
      this.resetSzzykTotal();
    },
    searchMethod () {
      // if (this.keyWord && this.keyWord.length > 0) {
      //   this.$emit("currentState", false); // 再次搜索时让重新请求回来的总数显示
      this.$router.push({
        path: `/${this.school_code}/zy/search`,
        query: {
          // keyWord: this.keyWord,
        },
      });
      // } else {
      //   this.$message.error("检索词不能为空");
      // }
    },
    loginModal (val) {
      let that = this;
      // 如果需要统一登录,跳转
      let param = {
        format: "json",
        school_code: that.school_code,
        from: window.location.href,
      };
      that.schoolLoginRedirect(param).then((res) => {
        if (
          res.code == "0000" &&
          res.data &&
          !(res.data.redirect.indexOf(services.APPS_WEB) > -1)
        ) {
          return window.open(res.data.redirect, "_self");
          // return window.open(`${services.APPS_WEB}/${this.school_code}/login?from=${window.location.href}`, "_self")
        } else {
          if (val) {
            that.getAppsImageCaptcha();
          }
          that.setAppsLoginVisible(val);
        }
      });
    },
    // 退出登录
    async logoutEvent () {
      let that = this;
      await that.requestAppsLogout().then(() => {
        if (
          utils.whiteList.some(
            (item) => `/${this.school_code}${item}` == `${this.$route.path}`
          )
        ) {
          that.$router.push({ path: `/${that.school_code}/` });
          that.loginModal(true);
        }
      });

      // 100017 人文素养页面需要判断登录,这个页面退出登录后,自动跳转到/zy/xxzyk
      if (
        this.school_code == utils.sdcm_code &&
        window.location.href.indexOf("/xxzyk/rwsy") > -1
      ) {
        window.open(`/${this.school_code}/zy/xxzyk`, "_self");
      }
    },
    toSzyskDetail (item) {
      let that = this;
      that.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = that.$router.resolve({
          path: `/${that.school_code}/zy/szysk/details`,
          query: {
            id: item.id,
            pid: item.pid,
            className: item.classname,
          },
        });
        window.open(routeUrl.href, "_blank");
      });
    },
    clickFunc (item) {
      if (item.name == "党建育人库") {
        window.open(`https://zhsz.jiaoyu.cn/100048/12/index.html`, this.target);
        return;
      }

      this.goAppsDetailsBeforeLogin().then(() => {
        if (item.name == "在线备课") {
          window.open(`${services.BEIKE_SERVER}/${this.school_code}/lesson/resource`, this.target);
        } else if (item.name == "使用帮助") {
          const routeUrl = this.$router.push(`/${this.school_code}/zy/syzn`);
          window.open(routeUrl.href, this.target)
        }
      });
    },

    clickRouter (item) {

      if (item.path.includes("/zy/region") && !item.path.includes("/zy/region/list")) {
        const routeUrl = this.$router.resolve({ path: `/${this.school_code}/zy/region` });
        window.open(routeUrl.href, this.target);
      } else {
        const routeUrl = this.$router.resolve({ path: `/${this.school_code}${item.path}` });
        window.open(routeUrl.href, this.target);
      }
    },

  },
};
</script>

<style lang="less" scoped>
.container {
    height: 100%;
}
.header-box {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 50;
}
.head-two {
    padding: 0 0;
    width: 100%;
    height: 110px;
    background-color: transparent;
    &.ynjd {
        background-image: url('../assets/image/common/48-header-bg.jpg');
        background-size: 100% auto;
        .flex-center {
            .left-imgs {
                .schoollogo {
                    max-height: 38px;
                }
            }
        }
    }
    .menu-list {
        width: 100%;
        display: flex;
        height: 44px;
        justify-content: space-evenly;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('../assets/image/sccj/menu-bg.png');
        background-size: cover;
        .menu-items {
            font-weight: bold;
            font-size: 15px;
            color: #ffffff;
            height: 44px;
            line-height: 44px;
            cursor: pointer;
            a {
                color: #ffffff;
            }
            &.active,
            &.active a {
                color: #ffeaa0;
            }
        }
    }
    .flex-center {
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: space-between;
        .left-imgs {
            display: flex;
            align-items: center;
            .schoollogo {
                max-height: 50px;
                width: auto;
            }
            .split-line {
                width: 1px;
                height: 20px;
                background: #e6e3e3;
                margin: 0 20px;
                display: inline-block;
            }
            .szzyk-img {
                margin-left: 4px;
                cursor: pointer;
            }
            .chayi-img {
                cursor: pointer;
                margin-left: 4px;
                height: 36px;
            }
        }

        .search-middle-box {
            margin: 0 40px 0 auto;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .center-link {
                font-weight: bold;
                font-size: 14px;
                color: #b81516;
                img {
                    width: 16px;
                    height: auto;
                    display: inline-block;
                    margin: 2px 8px 0 0;
                }
            }

            .search-button {
                display: inline-block;
                width: 52px;
                height: 36px;
                margin: 0 0 0 40px;
               background: #FFFFFF;
                border-radius: 18px;
                border: 1px solid #FBCDCD;
                text-align: center;
                cursor: pointer;
                img {
                    width: 16px;
                    height: auto;
                    margin: 8px auto 0;
                    display: inline-block;
                }
            }
            .search-list {
                font-size: 12px;
                color: #887a79;
                line-height: 32px;
                padding-left: 12px;
                .search-item {
                    display: inline-block;
                    margin-right: 14px;
                    cursor: pointer;
                    &:hover {
                        color: #df4531;
                    }
                }
            }
        }
        .login-box {
            float: right;
            text-align: right;
            line-height: 30px;
            .free-trial {
                color: #e54656;
                font-size: 12px;
                line-height: 30px;
                display: inline-block;
            }
            .login {
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                display: inline-block;
                cursor: pointer;
                width: 114px;
                height: 36px;
                background: #DF4E19;
                border-radius: 18px;
                text-align: center;
                line-height: 36px;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 12px;
                    height: 13px;
                    background-size: cover;
                    vertical-align: -1px;
                    background-image: url('../assets/image/sccj/login.png');
                    margin-right: 8px;
                }
            }
            .register {
                color: #e54656;
                font-size: 12px;
                display: inline-block;
                cursor: pointer;
                &::after {
                    content: '';
                    width: 2px;
                    height: 9px;
                    background: #eeeff0;
                    display: inline-block;
                    margin: 0 12px;
                }
            }
            .login-dropdown-box {
                height: 30px;
                position: relative;
                display: inline-block;
                .login-after {
                    color: #121212;
                    font-size: 14px;
                    display: inline-block;
                    line-height: 30px;
                    &::after {
                        display: inline-block;
                        content: '';
                        width: 7px;
                        height: 5px;
                        margin-left: 5px;
                        background-image: url('../assets/image/common/up-icon.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 100% auto;
                        vertical-align: 3px;
                        transition: background-image 0.3s;
                    }
                    &::before {
                        content: '';
                        display: inline-block;
                        width: 19px;
                        height: 17px;
                        background-size: cover;
                        vertical-align: -2.5px;
                        background-image: url('../assets/image/common/login.png');
                        margin-right: 8px;
                    }
                }
                .login-sub-box {
                    display: none;
                    position: absolute;
                    padding: 10px 20px;
                    box-sizing: border-box;
                    top: 30px;
                    left: -35px;
                    width: 140px;
                    text-align: left;
                    background-color: transparent;
                    box-shadow: 0px 1px 6px 0px rgba(130, 130, 130, 0.2);
                    border-radius: 2px;
                    transition: background-color 0.3s;
                    z-index: 100;
                    .hover-item {
                        display: block;
                        line-height: 26px;
                        &:hover {
                            background-color: #fff;
                        }
                        a {
                            color: #393939;
                            font-size: 12px;
                            display: block;
                            &:hover {
                                color: #e64757;
                                background-color: #fff;
                            }
                        }
                    }
                    .login-lines {
                        width: 100%;
                        height: 1px;
                        background: #f3f4f5;
                        margin: 5px 0;
                    }
                }
                &:hover .login-after::after {
                    background-image: url('../assets/image/common/down-icon.png');
                    background-size: 100% auto;
                    background-repeat: no-repeat;
                    background-position: center;
                }
                &:hover .login-sub-box {
                    display: block;
                    background-color: #ffffff;
                }
            }
        }
    }
}
</style>
